<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center" @click="goHome">
        <v-img
          alt="AddToTheStory Logo"
          class="shrink mr-2"
          contain
          src="./assets/Closed_Book.png"
          transition="scale-transition"
          width="40"
        />

        Add to the Story
      </div>
      <v-spacer></v-spacer>
      <div v-if="$route.path != '/' && $route.path != '/create'">
        <v-btn rounded small color="#FFA500" @click="goCreate"><b>Start a New Story</b></v-btn>
      </div>
    </v-app-bar>

    <v-content>
      <router-view :key="$route.fullPath"></router-view>
    </v-content>
    <GDPR></GDPR>
    <Footer></Footer>
  </v-app>
</template>

<script>
import GDPR from './components/GDPR.vue'
import Footer from './components/Footer.vue'
export default {
  name: 'App',

  components: {
    GDPR, Footer
  },

  data: () => ({
    //
  }),

  methods: {
    goHome: function () {
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' })
      }
    },
    goCreate: function () {
      if (this.$route.path !== '/create') {
        this.$router.push({ path: '/create' })
      }
    }
  }
}
</script>
